<template lang="pug">
  date-picker.width-100(
    :placeholder='placeholder'
    :minimumView='type'
    :language='language'
    :format='format'
    :value='value'
    @selected='change'
    calendarClass='calendar-container'
    wrapperClass='calendar-wrapper'
    inputClass='input-base input-border text-normal'
  )
</template>

<script>
import DatePicker from 'vuejs-datepicker'
import { mapState } from 'vuex'
import { en, es, ca } from 'vuejs-datepicker/dist/locale'

export default {
  props: {
    type: { type: String, default: 'date' },
    format: { type: String, default: 'dd MMM yyyy' },
    name: { type: String },
    value: { type: String },
    placeholder: { type: String }
  },
  components: { DatePicker },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale
    }),
    language() {
      if (this.locale === 'ES_AR') return es
      else if (this.locale === 'EN_US') return en
      else return ca
    }
  },
  methods: {
    change(date) {
      this.$emit('change', date, this.name)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

/deep/ .calendar-wrapper{
  width: 100%;
}

/deep/ .calendar-container{
  margin-top: 5px;
  background-color: $white;
  border: 1px solid $light-gray;
  border-radius: 6px;
  max-width: none;
  width: 100%;
  header{
    height: 40px;
    display: flex;
    place-content: center;
    &>span{
      display: flex;
      height: 100%;
      place-items: center;
      place-content: center;
    }
  }
  .cell{
    border-radius: 5px;
    &.day-header{
      &:hover{
        border: none !important;
      }
    }
    &:hover{
      border: 1px solid $blue !important;
    }
    &.selected{
      &:hover{
        background-color: $blue;
      }
      background-color: $blue;
      color: $white;
    }
  }
}
</style>
